const footerNav = [
  { href: "#today", label: "今日更新" },
  { href: "#hot", label: "热门连载" },
  { href: "#reminder", label: "追更提醒" },
  { href: "#category", label: "题材分类" },
  { href: "#faq", label: "追更FAQ" },
  { href: "#about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-50/60 border-t border-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="flex flex-col lg:flex-row justify-between gap-8 md:gap-10">
          {/* brand */}
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-500 text-background-50 font-heading text-lg">
                追
              </span>
              <span className="font-heading text-xl text-primary-700">51漫画追更</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              更新最快的免费漫画追更站。热门连载更新提醒、新章节第一时间推送，同步全网最新话，追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-qq-line", "ri-weibo-line", "ri-douban-line"].map((icon) => (
                <a
                  key={icon}
                  href="#about"
                  aria-label="社交媒体"
                  className="flex items-center justify-center w-9 h-9 rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* nav */}
          <nav className="grid grid-cols-2 gap-8 md:gap-12" aria-label="页脚导航">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950">快速导航</h4>
              <ul className="mt-4 space-y-3">
                {footerNav.slice(0, 3).map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950">了解更多</h4>
              <ul className="mt-4 space-y-3">
                {footerNav.slice(3).map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* contact */}
          <div className="max-w-xs">
            <h4 className="text-sm font-semibold text-foreground-950">联系与反馈</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" />
                <span>support@51freecomic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600" />
                <span>每日 24 小时同步更新</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-earth-line text-primary-600" />
                <span>同步全网最新连载</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 51漫画追更 · 51免费漫画网追更. 保留所有权利。</p>
          <p className="text-xs text-foreground-500">免费漫画 · 免注册直读 · 更新最快</p>
        </div>
      </div>
    </footer>
  );
}